import { c as _c } from "react/compiler-runtime";
interface ProgressBarProps {
  progress: number;
}
export const ProgressBar = t0 => {
  const $ = _c(2);
  const {
    progress
  } = t0;
  const t1 = `${progress}%`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="h-4 overflow-hidden rounded-pill bg-Gray-50"><div className="h-full bg-B-500" style={{
        width: t1
      }} /></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};